module.exports = __webpack_public_path__ + "static/media/smile.c9a597c0.svg";